/**
 * Ícono de un trofeo: la medalla de Santiago (18/09/2026) si el trofeo tiene
 * arte, y el emoji de siempre si no — así un trofeo nuevo sin medalla todavía
 * no queda con un hueco en el cofre. Ver src/config/trophyMedals.ts.
 *
 * Mantiene la clase del emoji que reemplaza (`className`) para heredar el
 * tamaño y el estado bloqueado (escala de grises) que ya define cada vista.
 */

import { medalSrc, medalLabel } from '../../config/trophyMedals';

interface TrophyMedalProps {
  trophyId: string;
  emoji: string;
  className: string;
}

export function TrophyMedal({ trophyId, emoji, className }: TrophyMedalProps) {
  const src = medalSrc(trophyId);
  if (!src) {
    return (
      <span className={className} aria-hidden="true">
        {emoji}
      </span>
    );
  }
  return (
    <img
      src={src}
      // « Communication · Bronze »: la categoría y el metal no aparecen en
      // ningún otro texto de la tarjeta.
      alt={medalLabel(trophyId) ?? ''}
      title={medalLabel(trophyId) ?? undefined}
      className={`${className} trophy-medal`}
      draggable={false}
      loading="lazy"
      decoding="async"
    />
  );
}

export default TrophyMedal;
